export default binding => {
    if (typeof binding.value !== 'function') {
        console.error(`[v-${binding.name}:] provided expression ${binding.expression} is not a function.`);

        return false;
    }

    return true;
};
